import { declareStringWithPlaceholders } from "@1js/localization";

export const PluginTooltip = declareStringWithPlaceholders(
  "promptLibrary.PluginTooltip",
  {
    text: ({ extensionName }) =>
      `Make sure ${extensionName} is on before submitting your prompt.`,
    placeholders: {
      extensionName: "The name of the extension installed for user",
    },
    comment:
      "Tooltip that's displayed to user when user hovers over the info button icon on a Copilot prompt card for a plugin prompt",
  }
);

export const TryInLabel = declareStringWithPlaceholders(
  "promptLibrary.TryInLabel",
  {
    text: ({ productName }) => `Try it in ${productName}`,
    placeholders: {
      productName:
        "the name of the product or service, like Business Chat, Word, or Excel",
    },
    comment:
      "Label for the prompt stating what product it is for. Full text could be for example 'Try in Business Chat'",
  }
);
